import api from "../utilities/fetching";
import { LightPayload, Table } from "../utilities/types";

const TABLE_CACHE_KEY = "billiardTables";

export const tableService = {
  // Fetches from the API (your existing function)
  async fetchTablesFromApi(): Promise<Table[]> {
    const response = await api.get<{ data: { table: Table[] } }>(`tables`);
    return response.data.table;
  },

  // Gets tables from the local cache
  getTablesFromCache(): Table[] {
    const cachedData = localStorage.getItem(TABLE_CACHE_KEY);
    return cachedData ? JSON.parse(cachedData) : [];
  },

  // Saves tables to the local cache
  saveTablesToCache(tables: Table[]) {
    localStorage.setItem(TABLE_CACHE_KEY, JSON.stringify(tables));
  },

  async fetchHistory(
    page: number,
    filters: {
      table: string | number;
      startDate: Date;
      endDate: Date;
      sortBy: string;
    },
  ) {
    let endUrl = `stopwatch?page=${page}&perPage=10`;
    const formattedStartDate =
      filters.startDate.toISOString() || "2023-06-01T00:00:00.000Z";
    const formattedEndDate =
      filters.endDate.toISOString() || new Date().toISOString();

    endUrl += filters.table ? `&table=${filters.table || "0"}` : "";
    endUrl += `&start=${formattedStartDate}`;
    endUrl += `&end=${formattedEndDate}`;
    endUrl += `&sortBy=${filters.sortBy}`;

    const response = await api.get(`${endUrl}`);
    return await response;
  },

  async deleteHistory(id: number) {
    const response = await api.delete(`stopwatch/${id}`);
    return await response;
  },

  async fetchAvailability() {
    const response = await api.get(`public/billiards`);
    return await response;
  },
};

export default tableService;
